import {Component, Input, TemplateRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {PrApplicationService, PrOrdersService, PrValidationService} from '@irb/irb-editors/editor-portfolio-result/services';
import {
    IPortfolioResultRequest,
    IPortfolioResultResponse, PrActionState
} from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model';
import {IrbRebalanceEvents} from '@irb/irb-rebalance/irb-rebalance.events';
import {IrbDialogsEvents} from '@irb/irb-dialogs/irb-dialogs.events';
import {AppService} from '@irb/app.service';
import {IApplyFilterOnLanding, IUserDetails} from "@irb/app.model";
import {IWorkflowDialogData} from "@irb/irb-rebalance/result-summary/result-summary.model";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';
import {IrbAppEvents} from "@irb-common/events";
@Component({ standalone: false,
    selector: 'irb-com-pr-action-buttons',
    templateUrl: './com-pr-action-buttons.component.html',
    styleUrls: ['./com-pr-action-buttons.component.scss','../../../irb-common/styles/dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComPrActionButtonsComponent {

    @Input()
    state: PrActionState;

    @Input()
    data: IPortfolioResultResponse;

    @Input()
    isModified: boolean;

    @Input()
    isAutomated: boolean;

    @ViewChild("workflowDialogTemplate")
    workflowDialogTemplate: TemplateRef<any>;

    workflowDialogData:IWorkflowDialogData;

    userDetails: IUserDetails;

    constructor(private pras: PrApplicationService,
                private dialog: MatDialog,
                private as: AppService,
                private ats: AnalyticsService, 
                private pros: PrOrdersService,
                private prvs: PrValidationService) {
        this.as.getUserDetails().subscribe((res: IUserDetails) => {
            if (res) {
                this.userDetails = res;
            }
        });
    }

    get showButtons(): boolean {
        return (!this.state.isUnresolved && this.state.actionRequired) ||
            (this.state.ordersProposed && this.state.userRemovedOrders || this.state.isManualAdjust);
    }
    get showOnBlotter(): boolean {
        return this.state && this.state.isApproved;
    }
    get showReEnable(): boolean {
        return this.state.isIgnored || this.state.isRefused;
    }

    get showRecall(): boolean {
        return !this.showReEnable && this.state.isApproved && !this.state.hasError;
    }

    get showApproveOrRefuse(): boolean {
        return !this.showReEnable && !this.state.isApproved;
    }

    get isDisabled(): boolean {
        return this.state.ordersProposed && this.state.userRemovedOrders;
    }

    get isTrader(): boolean {
        return  this.userDetails && this.userDetails.isTrader;
    }

    checkPfDeleted(action: string) {
        this.pras.checkPfDeleted(this.data, action);
    }

    checkWarningsAndApprove() {
        setTimeout(() => {
            if(this.pros.shareQtyUpdateInProgress) {
                this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
                setTimeout(() => this.checkWarningsAndApprove(),250);
                return;
            } else if(this.prvs.validationInProgress) {
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                this.prvs.pendingFunction = () => this.checkWarningsAndApprove();
                return;
            }

            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            this.ats.trackClickEvent("lc_approve");
            if (this.pras.checkUserTradeAccessOfAccounts(this.data, "APPROVE")) {
                if (this.data.hpnNo > 0) {
                    this.workflowDialogData = {
                        title: 'High Priority Notes',
                        isGridRequired: true,
                        gridOptions: {
                            floatingFilter: false,
                            columnDefs: [
                                {
                                    headerName: 'Portfolio Name',
                                    colId: 'portfolioName',
                                    value: this.data.portfolioName,
                                    cellRendererSelector: () => {
                                        return {
                                        component: "cellRendererFormatter",
                                        params: {value: this.data.portfolioName}
                                    }}
                                    , minWidth:225, flex: 2
                                },                            {
                                    headerName: 'Date Last Edited',
                                    field: 'modifiedDate',
                                    colId: 'modifiedDate',
                                    sort: "desc",
                                    cellRendererSelector: () => {
                                        return {
                                            component: "cellRendererFormatter",
                                            params: {value: this.data.portfolioName}
                                        }}
                                        ,minWidth:170, width:170
                                    },                           
                                    {
                                        headerName: 'By',
                                        field: 'modifiedBy',
                                        colId: 'modifiedBy',
                                        cellRenderer: 'cellRendererFormatter',
                                        minWidth:90, width:90
                                    },
                                    {
                                        headerName: 'Note',
                                        field: 'comment',
                                        colId: 'comment',
                                        cellRenderer: 'cellRendererFormatter',
                                        minWidth: 225
                                    }
                                ]
                            },
                            rowData: this.data.highPriorityNotesList,
                            warning: 'The following portfolio(s) have high priority notes.',
                            gridCounter: '1 portfolio(s)',
                            nextAction: () => {
                                this.pras.checkNegativeCashAndPerformAction(this.data, "negativeCashAndApprove", this.isModified, (r: IPortfolioResultRequest) => {
                                    this.as.fireEvent(IrbRebalanceEvents.SAVE_PORTFOLIO_RESULT_DETAIL, r);
                                });
                            }
                        };
                        this.openDialog();
                    } else {
                        this.pras.checkNegativeCashAndPerformAction(this.data,"negativeCashAndApprove", this.isModified, (r: IPortfolioResultRequest) => {
                            this.as.fireEvent(IrbRebalanceEvents.SAVE_PORTFOLIO_RESULT_DETAIL, r);
                        });
                    }
                }
        },250);
    }

    workflowProceed(){
        this.dialog.closeAll();
        //this.openDialog();
        const nextObj = this.workflowDialogData.nextAction();
        if(nextObj){
            this.workflowDialogData = nextObj;
        }
    }

    openDialog(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.panelClass = "irb-dialog";
        dialogConfig.autoFocus = false;
        this.dialog.open(this.workflowDialogTemplate, dialogConfig);
    }

    refuse() {
        this.ats.trackClickEvent("lc_refuse");
        const r: IPortfolioResultRequest = this.pras.getPortfolioResultRequest(this.data, false, "REFUSE");
        this.as.fireEvent(IrbRebalanceEvents.SAVE_PORTFOLIO_RESULT_DETAIL, r);
    }

    refuseAndResubmit() {
        this.ats.trackClickEvent("lc_refuseresub");
        this.as.fireEvent(IrbDialogsEvents.SHOW_PR_RESUBMIT, {
            data: this.data,
            onProceed: ((d: any) => {
                this.data.newRebalanceName = d.newRebalanceName;
                this.data.newTradeExplanation = d.newTradeExplanation;
                const r: IPortfolioResultRequest = this.pras.getPortfolioResultRequest(this.data, false, "REFUSE_AND_RESUBMIT");
                this.as.fireEvent(IrbRebalanceEvents.SAVE_PORTFOLIO_RESULT_DETAIL, r);
            }).bind(this)
        });
    }

    viewOrdersOnBlotter() {
            const state: IApplyFilterOnLanding = {
                tabname: (this.isAutomated) ? 'Automated' : 'Active',
                isUpdatRequired: true,
                filterModels: [
                    { name: 'rebalanceResultId', filter: this.data.rebalId.toString(), isUpdatRequired: true },
                    { name: 'portfolioName', filter: this.data.portfolioName.toString(), isUpdatRequired: true }
                ]
            } as IApplyFilterOnLanding;

            this.as.fireEvent(IrbRebalanceEvents.NAVIGATE_FROM_PORTFOLIO_RESULT_DETAIL, {
                path: '/orders/order-blotter',
                state: state
            });
    }
}
